var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SF_60x60_2x",
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(8 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M18,10a7.976,7.976,0,0,1,6,2.726V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2h8.263A8.007,8.007,0,0,1,18,10Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 24,
    height: 3,
    transform: "translate(0 3.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M18,12a6,6,0,1,0,6,6A6.018,6.018,0,0,0,18,12Z",
    fill: "#ef5323"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M20.7,19.61c0-1.311-1.047-1.764-1.982-2.04v-2a3.585,3.585,0,0,1,.815.248l.5.249.5-1.009-.506-.249a4.757,4.757,0,0,0-1.31-.375V13.5H17.592v.939a2.025,2.025,0,0,0-1.955,1.95c0,1.3,1.027,1.755,1.955,2.032v2.025a5.754,5.754,0,0,1-1.38-.293l-.529-.191L15.3,21.02l.529.191a6.89,6.89,0,0,0,1.762.37V22.5h1.125v-.932C20.489,21.35,20.7,20.153,20.7,19.61Zm-3.937-3.221c0-.51.43-.722.83-.808v1.657C17.022,17.035,16.762,16.819,16.762,16.389Zm1.955,4.045V18.751c.59.2.857.421.857.859C19.574,19.81,19.571,20.285,18.717,20.434Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.be1cb94582db28a6fad74819bb96b9b9.svg";
export { ForwardRef as ReactComponent };